var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MainFrame'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',{staticClass:"bg-white shadow"},[_c('div',{staticClass:"max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8"},[_c('h1',{staticClass:"text-3xl font-bold text-gray-900"},[_vm._v(" HomePage ")])])]),_c('main',[_c('div',{staticClass:"max-w-7xl mx-auto py-6 sm:px-6 lg:px-8"})])])
}]

export { render, staticRenderFns }